import React, { useEffect } from "react"
import DocumentMeta from "react-document-meta"
import { useNavigate, Link } from "react-router-dom"
import AccordionItem from "../components/elements/AccordionItem"
import Header from "../components/Header"
import Footer from "../components/Footer"

function FAQ() {
	const navigate = useNavigate()

	// SEO Meta Tags

	const meta = {
		// title: "Mit merci zum Muttertag filmreif Danke sagen!",
		// canonical: "https://arvato-hawaiian-tropic-2023.de/",
		// meta: {
		// 	name: {
		// 		robots: "noindex, nofollow",
		// 	},
		// },
	}

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<DocumentMeta {...meta}>
			<div className="light bg-cover">
				<Header type="logo" />
				<div className="text-back  mx-auto  py-8 ">
					<div className=" bg-[url(/src/bgimages/form-bg.png)] bg-cover py-8">
						<h2 className="h2 mb-8 mt-12 text-center font-Alpro text-2xl text-white lg:mt-24">FAQ </h2>
					</div>
					<div className="container max-w-[800px] mx-auto">
						<h2 className="h2 mb-8 mt-12 text-center font-Alpro text-lg text-blue lg:mt-24">1. Allgemeine Informationen </h2>
						<AccordionItem headline="Wer ist der Veranstalter der Aktion?" num="1.">
							<p className="text-back mb-2">
								Veranstalter ist
								<br /><br />
								Danone Deutschland GmbH<br />
								Am Hauptbahnhof 18<br />
								60329 Frankfurt am Main<br />
								<br />
								(im Folgenden „Veranstalter“ genannt)
								<br /><br />
								Im Auftrag der Danone Deutschland GmbH ist die direct services Gütersloh GmbH bei
								der Durchführung der Aktion unterstützend tätig.
							</p>
						</AccordionItem>
						<AccordionItem headline="Wer kann an der Aktion teilnehmen?" num="2.">
							<>
								<p className="text-back mb-2">Teilnahmeberechtigt sind Personen mit Wohnsitz in Deutschland, die mindestens 18
									Jahre alt sind und ein Konto im SEPA-Raum besitzen. Es ist nicht erlaubt im Namen von
									anderen Personen (z.B. Freunden oder Verwandten) teilzunehmen oder Dritte mit der
									Teilnahme zu beauftragen. Mitarbeitende des Veranstalters und Personen, die an der
									Konzeption oder Durchführung beteiligt sind, dürfen nicht teilnehmen. Das gilt auch für
									deren Angehörige. Personen können auch nachträglich ausgeschlossen werden, wenn
									sich erst zu einem späteren Zeitpunkt herausstellt, dass sie nicht zur Teilnahme
									berechtigt waren.</p>
							</>
						</AccordionItem>
						<AccordionItem headline="Wie lange kann ich an der Aktion teilnehmen?" num="3.">
							<p className="text-back mb-6">
								Der Aktionszeitraum beginnt am 05.01.2026 und endet am 08.05.2026. Kassenbelege
								können bis zum 08.05.2026, 23:59 Uhr auf der Aktionsseite hochgeladen werden. Ein
								Teilnahmevorgang muss innerhalb dieses Zeitraums vollständig abgeschlossen
								werden, um als gültige Teilnahme akzeptiert zu werden. Über die erfolgreiche
								Teilnahme wird der Teilnehmer auf der Aktionsseite informiert.
							</p>
							<p className="text-back mb-6">
								Der Veranstalter kann das Gewinnspiel jederzeit pausieren oder vorzeitig beenden,
								wenn dies aus technischen, organisatorischen oder rechtlichen Gründen notwendig ist.
								Insbesondere kann die Aktion vom Veranstalter vorzeitig beendet werden, wenn die
								Teilnehmerzahl von 50.000 erreicht ist. Sollte die Aktion vorzeitig beendet sein wegen
								Erreichen der 50.000 Teilnahmen, wird dies auf <a href="https://www.alpro.com/de/campaign" className="underline" target="_blank" rel="noopener noreferrer">www.alpro.com/de/campaign</a>
								{" "}kommuniziert. Der Veranstalter ist berechtigt den Teilnahmezeitraum jederzeit zu
								verlängern.
							</p>
							<p className="text-back mb-6">
								Änderungen am Teilnahmezeitraum werden entweder auf der Aktionswebsite, der
								Unternehmenswebsite oder auf einem Social Media Profil des Veranstalters
								veröffentlicht.
							</p>
						</AccordionItem>
						<AccordionItem headline="Welche Produkte sind für die Teilnahme berechtigt?" num="4.">
							<p className="text-back mb-6">
								Folgende Alpro Produkte (Joghurtalternativen) nehmen an der Aktion teil:
							</p>
							<ul>
								<li>Alpro®- Soja-Joghurtalternative Natur, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Natur mit Mandeln, 400g</li>
								<li>Alpro®- Soja-Joghurtalternative Natur mit Kokosnuss, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Natur mit Hafer, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Hafer+ Natur, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Natur Ohne Zucker, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative This is not Y*gurt, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Heidelbeere, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Vanille, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Pfirsich, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Kirsche, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Zitrone-Limette, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Erdbeere, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Erdbeere Banane, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Mango ohne Zuckerzusatz, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Ananas-Passionsfrucht ohne Zuckerzusatz, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Himbeere-Apfel ohne Zuckerzusatz, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Rote Früchte mit Datteln ohne Zuckerzusatz, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Dessert Style Apfelstrudel Geschmack, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Dessert Style Lemon-Cheesecake Geschmack, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Dessert Style Blueberry Muffin Geschmack, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Skyr Natur ohne Zucker, 400g</li>
								<li>Alpro®- Soja-Joghurtalternative Skyr Vanille, 400g</li>
								<li>Alpro®- Soja-Joghurtalternative Skyr Mango, 400g</li>
							</ul>
							<p className="text-back mt-2">
								Als Teilnahmevoraussetzung gilt der Kauf von mindestens einem Produkt.
							</p>
						</AccordionItem>
						<AccordionItem headline="Wie oft kann eine Person teilnehmen?" num="5.">
							<p className="text-back mb-6">Sofern die Teilnahmevoraussetzungen (vgl. Abschnitt „Welche
								Teilnahmevoraussetzungen gib es?“) erfüllt sind, darf eine Person einmal an der Aktion
								teilnehmen. Beim Kauf mehrerer Produkte auf einem Beleg wird nur ein Produkt mit
								dem teuersten Kaufpreis erstattet.
							</p>
						</AccordionItem>
						<h2 className="h2 mb-8 mt-12 text-center font-Alpro text-lg text-blue lg:mt-24">2. Durchführung und Abwicklung </h2>
						<AccordionItem headline="Wie kann ich an der Aktion teilnehmen?" num="6.">
							<p className="text-back mb-2">
								Die Teilnahme erfolgt nur auf der Aktionswebsite unter <a href="https://www.alpro.com/de/campaign" className="underline" target="_blank" rel="noopener noreferrer">www.alpro.com/de/campaign</a>.
								{" "}Auf dieser Website müssen alle für die Teilnahme erforderlichen Daten von der
								teilnehmenden Person angegeben werden. Eine Teilnahme über andere Kanäle (z.B. E-Mail, SMS, Post, Telefon) ist nicht möglich.
							</p>
							<p className="text-back mb-2">
								Als Voraussetzung für eine gültige Teilnahme gilt der Kauf von mindestens einem
								Aktionsprodukt (siehe Abschnitt: „Welche Aktionsprodukte werden für die Teilnahme
								akzeptiert?“). Der Kauf muss durch ein Foto des Kassenbeleges nachgewiesen werden.
								Das Foto muss auf der Aktionswebsite hochgeladen werden. Dabei müssen die
								Bezeichnung und der Kaufpreis des Aktionsproduktes deutlich auf dem Beleg sichtbar
								sein. Der Kauf kann bei einem beliebigen Händler oder in einem Online-Shop erfolgen,
								der ein Aktionsprodukt im Sortiment führt. Ein Mindesteinkaufswert wird nicht
								vorausgesetzt, weder für die Aktionsprodukte noch für den gesamten Einkauf. Die
								Aktionsprodukte müssen im Zeitraum vom 05.01.2026 bis einschließlich 08.05.2026
								gekauft worden sein. Der Kaufzeitpunkt muss auf dem Kassenbeleg sichtbar sein.
							</p>
						</AccordionItem>
						<AccordionItem headline="Welche Pflichtangaben müssen auf dem Kaufbeleg zu sehen sein?" num="7.">
							<p className="text-back mb-2">
								Auf dem Foto müssen alle relevanten Teile des Kassenbelegs gut sichtbar sein.
								Screenshots von digitalen Kaufbelegen sind möglich. Neben den Angaben, die als
								Teilnahmevoraussetzung erforderlich sind, müssen zusätzlich immer der Name des
								Händlers, der Kaufzeitpunkt (Datum und im Idealfall auch die Uhrzeit) und die
								Gesamtsumme des Kassenbelegs enthalten sein. Es ist nicht erlaubt denselben
								Kassenbeleg für mehrere Teilnahmen zu nutzen. Daten, die für die Teilnahme nicht
								erforderlich sind (z.B. sonstige gekaufte Produkte) können geschwärzt werden. Alle
								Kassenbelege werden automatisiert und nach Bedarf auch manuell überprüft. Bei
								Zweifel an der Echtheit des Belegs sowie bei nicht-lesbaren oder fehlenden
								Informationen ist eine Teilnahme ausgeschlossen.
							</p>
						</AccordionItem>
						<AccordionItem headline="Wie lädt man das Foto vom Kassenbon richtig hoch?  " num="8.">
							<p className="text-back">Es können beim Upload nur Fotos im Format JPG, PNG und PDF und einer maximalen
								Größe von 8 MB pro Foto hochgeladen werden. Auf dem Kassenbon müssen die
								folgenden Daten erkennbar sein: Kaufdatum, Kaufpreis des Produktes, Bonsumme,
								Einkaufsstätte sowie das Produkt. Auf dem Kassenbon abgebildete personenbezogene
								Daten (z. B. Namen von Beschäftigten) sind nicht abzulichten oder vorab zu schwärzen
								oder in sonstiger Weise unkenntlich zu machen. Unvollständige sowie verspätete
								Angaben können leider nicht berücksichtigt werden.   </p>
							<p className="text-back">Der Veranstalter behält sich vor, den Original-Kassenbon nachzufordern. </p>
						</AccordionItem>
						<AccordionItem headline="Wo findet man die IBAN/BIC?" num="9.">
							<p className=" text-back">
								Die persönliche IBAN-Nummer und den BIC findet man auf der Vorder- und/oder
								Rückseite der Bankkarte sowie im Online-Banking. Die Zahlenfolge der IBAN für
								Deutschland beginnt stets mit DE und enthält 22 Zeichen.
							</p>
						</AccordionItem>
						<h2 className="h2 mb-8 mt-12 text-center font-Alpro text-lg text-blue lg:mt-24">3. Nach der Teilnahme </h2>
						<AccordionItem headline="Welchen Cashback Betrag erhalte ich?" num="10.">
							<p className=" text-back">
								Es wird jeweils der Kaufpreis für ein Alpro Produkt (Joghurtalternative) auf dem
								Kassenbeleg erstattet. Der Höchstbetrag beträgt 2,40 €. Wenn 50.000 Teilnehmer
								registriert sind, werden keine weiteren Einkäufe erstattet.
							</p>
						</AccordionItem>
						<AccordionItem headline="Wie erfolgt die Einlösung des Cashbacks?" num="11.">
							<p className=" text-back">
								Um den Kaufpreis erstattet zu bekommen, muss ein Kassenbeleg-Foto des Folgekaufs
								auf der Aktionswebsite hochgeladen werden und drei Pflichtfragen zum Produkt
								beantwortet werden.
							</p>
							<p className=" text-back">
								Der Veranstalter kann die Auszahlung bei begründeten Zweifeln an der Echtheit des
								Kassenbelegs oder bei sonstigen Verstößen gegen die Regeln der Aktion verweigern. Es
								findet ggf. eine zusätzliche manuelle Überprüfung der Teilnahmedaten und des
								Kassenbelegs statt. Die Auszahlung erfolgt als Überweisung in Euro an das persönliche
								Girokonto der teilnehmenden Person. Hierfür muss die IBAN des eigenen Kontos
								angegeben werden. Es erfolgt keine Auszahlung an Konten von anderen Personen oder
								an Konten bei ausländischen Banken oder in Fremdwährungen. Die teilnehmende
								Person ist für die korrekte Eingabe der IBAN verantwortlich. Wenn versehentlich eine
								falsche IBAN angegeben wurde, ist keine nachträgliche Korrektur möglich. In diesem
								Fall verfällt der Anspruch auf die Cashback-Auszahlung. Sofern alle
								Teilnahmevoraussetzungen erfüllt sind, wird der Kaufpreis innerhalb eines Zeitraums
								von vier Wochen auf das angegebene Konto überwiesen.
							</p>
						</AccordionItem>
						<h2 className="h2 mb-8 mt-12 text-center font-Alpro text-lg text-blue lg:mt-24">4. Sonstiges</h2>
						<AccordionItem headline="Welche persönlichen Daten werden für die Teilnahme benötigt?  " num="12.">
							<p className=" text-back">
								Für die Teilnahme müssen die persönliche E-Mail-Adresse und der vollständige Name
								angegeben werden. Diese Informationen werden benötigt, um die Aktion sicher
								abwickeln zu können.
							</p>
							<p className=" text-back">
								Um eine Geld-zurück-Auszahlung in Anspruch zu nehmen, muss insbesondere auch die
								IBAN des eigenen Girokontos mitgeteilt werden. Diese Angabe ist freiwillig. Ohne
								angegebene IBAN kann jedoch keine Geld-zurück-Auszahlung stattfinden.
							</p>
							<p className=" text-back">
								Es müssen drei Pflichtfragen zum Produkt beantwortet werden.<br />
								Personenbezogen Daten, die sich möglicherweise auf einem Kaufbeleg befinden und
								für Teilnahme am Gewinnspiel nicht erforderlich sind, sollten geschwärzt werden (z.B.
								Adressdaten).
							</p>
						</AccordionItem>
						<AccordionItem headline="Wie werden Daten im Rahmen der Aktion verarbeitet?" num="13.">
							<p className=" text-back">
								Für die Abwicklung der Aktion ist es notwendig, dass personenbezogen Daten
								verarbeitet werden (z.B. E-Mail-Adresse und Name). Diese Daten werden vom
								Veranstalter und Dienstleistern des Veranstalters mit äußerster Sorgfalt und gemäß
								den gültigen Datenschutzbestimmungen verarbeitet. Details sind in der
								Datenschutzerklärung beschrieben.
							</p>
							<p className=" text-back">
								Alle Teilnahmedaten werden für die gesamte Dauer der Aktion gespeichert und
								spätestens 6 Wochen nach Ende der Aktion gelöscht, sofern keine besondere
								Einwilligung in eine längerfristige Speicherung erfolgte oder eine längerfristige
								Speicherung aus rechtlichen Gründen erforderlich ist. Eine längerfristige Speicherung
								erfolgt beispielsweise, falls die freiwillige Einwilligung für den Empfang eines
								Newsletters gegeben wurde oder im Falle der Nachweisbarkeit von Cashback-
								Transaktionen. Dabei werden nur die tatsächlich benötigten Daten gespeichert. Alle
								nicht benötigten Daten werden auch in diesen Fällen gelöscht.
							</p>
							<p className=" text-back">
								Darüber hinaus können statistische Daten gespeichert werden (z.B. für
								Nutzungsstatistiken). Statistische Daten werden nur in vollständig anonymisierter Form
								verarbeitet. Ein Rückschluss auf einzelne Personen ist dabei ausgeschlossen.
							</p>
						</AccordionItem>
						<AccordionItem headline="Werden Daten von teilnehmenden Personen veröffentlicht?" num="14.">
							<p className=" text-back">
								Der Veranstalter wird ohne Erlaubnis grundsätzlich keine Daten von teilnehmenden
								Personen veröffentlichen. Nur nach ausdrücklicher, vorheriger Einwilligung der
								teilnehmen Personen ist es möglich, dass beispielsweise die Gewinnernamen auf einer
								Website oder in einem Social Media Post genannt werden. Auf Wunsch erfolgt die
								Nennung dabei in anonymisierter Form.
							</p>
						</AccordionItem>
						<AccordionItem headline="Du hast keine Antwort auf deine Frage erhalten?" num="15.">
							<p className=" text-back">
								Das Service-Team ist per E-Mail unter{" "}
								<a href="mailto:info@gratistesten.alpro.com" className="underline">
									info@gratistesten.alpro.com
								</a>{" "}
								erreichbar.
							</p>
						</AccordionItem>
					</div>
					<div className="text-center text-xl text-blue">
						<Link
							to="/"
							className="mb-6 mt-12 block w-[100%] bg-blue p-4 font-Alpro text-[24px] font-bold uppercase tracking-wider text-white drop-shadow-md sm:w-[auto] md:text-[32px] trackind-wider rounded-full border-[3px] border-white lg:inline-block lg:py-2 lg:px-6"
						>
							Zurück
						</Link>
					</div>
				</div>
			</div>
			<Footer />
		</DocumentMeta>
	)
}
export default FAQ
